/**
 * Extracts the product OID from commodity pack data, e.g. 12751119
 * @param {object} data - Commodity pack item
 * @returns {number|null|undefined}
 */
export function getOid(data) {
    if (!data) return;
    let regex;
    try {
        // 1. attempt - webLink -> "https://www.alza.cz/honor-magic7-pro?dq=12751119"
        try {
            regex = /\?dq=\d{7,8}$/;
            if (regex.test(data.detailAction.webLink)) return parseInt(data.detailAction.webLink.split("?dq=").pop());
        } catch (e) { } // continue if error

        // 2. attempt - webLink -> "https://www.alza.cz/samsung-990-pro-2tb-d7516910.htm"
        try {
            regex = /-d\d{7,8}\.htm/;
            if (regex.test(data.detailAction.webLink)) {
                const match = data.detailAction.webLink.match(/-d(\d{7,8})\.htm/);
                return match ? parseInt(match[1]) : null;
            }
        } catch (e) { } // continue if error

        // 3. attempt - detailAction.href -> "https://www.alza.cz/Services/RestService.svc/v13/product/12751119?country=CZ&electronicContentOnly=False&pgrik=p__26752&ucik=u_in37lg1_95062"
        const match = data.detailAction.href.match(/\/product\/(\d{7,8})\?country=/);
        return match ? parseInt(match[1]) : null;
    }
    catch (error) {
        console.error('Error extracting OID:', error);
        return null;
    }
}
